import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import api from "../../api/axois";
import styles from "./ReservationDetail.module.css";
import { useUser } from "../../context/UserContext";
import ReviewsSection from "../../components/Reviews/ReviewsSection";
import ReviewForm from "../../components/Reviews/ReviewForm";
import {
  FaBed,
  FaShower,
  FaSnowflake,
  FaTv,
  FaWifi,
  FaConciergeBell,
  FaLaptop,
} from "react-icons/fa";

const toDateFlexible = (val) => {
  if (!val) return null;
  if (val instanceof Date) return isNaN(val.getTime()) ? null : val;
  if (typeof val === 'number') {
    const ms = val < 1e12 ? val * 1000 : val;
    const d = new Date(ms);
    return isNaN(d.getTime()) ? null : d;
  }
  if (typeof val === 'string') {
    const s = val.trim();
    const dmy = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/); // DD/MM/YYYY
    if (dmy) {
      const [_, dd, mm, yyyy] = dmy;
      const d = new Date(parseInt(yyyy, 10), parseInt(mm, 10) - 1, parseInt(dd, 10));
      return isNaN(d.getTime()) ? null : d;
    }
    const ymd = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/); // YYYY-MM-DD[ HH:mm:ss]
    if (ymd) {
      const [_, yyyy, mm, dd, hh, mi, ss] = ymd;
      const d = hh
        ? new Date(parseInt(yyyy, 10), parseInt(mm, 10) - 1, parseInt(dd, 10), parseInt(hh, 10), parseInt(mi || '0', 10), parseInt(ss || '0', 10))
        : new Date(parseInt(yyyy, 10), parseInt(mm, 10) - 1, parseInt(dd, 10));
      return isNaN(d.getTime()) ? null : d;
    }
    const d = new Date(s.includes(' ') ? s.replace(' ', 'T') : s);
    return isNaN(d.getTime()) ? null : d;
  }
  return null;
};

const formatEnGbDate = (val) => {
  const d = toDateFlexible(val);
  return d ? d.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '';
};

const formatEnGbTime = (val) => {
  const d = toDateFlexible(val);
  return d ? d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '';
};
const getSlideImages = (booking) => {
  if (booking?.room?.images && Array.isArray(booking.room.images) && booking.room.images.length > 0) {
    console.log("Using booking images:", booking.room.images);
    return booking.room.images;
  }
  console.log("No booking images found, using fallback images.");
  return [
    "/images/slide1.jpg",
    "/images/slide2.jpg",
    "/images/slide3.jpg"
  ];
};

const ReservationDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const [booking, setBooking] = useState(location.state?.booking || null);
  const [loading, setLoading] = useState(!location.state?.booking);
  const [error, setError] = useState(null);
    const { user, setUser } = useUser();
  const [activeImage, setActiveImage] = useState(0);
  const slideImages = getSlideImages(booking);
  // const fetchBookings = useCallback(async () => {
  //   setLoading(true);
  //   try {
  //     console.log('Fetching bookings...');
  //     const response = await api.get("/bookings");


  //     if (response.data && Array.isArray(response.data.bookings)) {

  //       // Log first booking details if exists
  //       if (response.data.bookings.length > 0) {

  //       }
  //       setBookings(response.data.bookings);
  //     } else {

  //       setBookings([]);
  //     }
  //   } catch (error) {
  //     setBookings([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, []);

  useEffect(() => {
    const fetchBooking = async () => {
      if (booking) return;
      setLoading(true);
      try {
        const res = await api.get(`bookings/me/${id}`);
        console.log("ReservationDetail: raw API response:", res.data);
        const b = res.data.booking ?? res.data;
        console.log("ReservationDetail: normalized booking:", b);
        console.log("ReservationDetail: booking.user:", b.user);
        setBooking(b);
      } catch (err) {
        console.error("ReservationDetail: fetch error", err);
        setError("Failed to load booking");
      } finally {
        setLoading(false);
      }
    };
    fetchBooking();
  }, [id, booking]);


  if (loading) return <div>Loading...</div>;
  if (error) return <div className={styles.error}>{error}</div>;
  if (!booking) return <div>Booking not found</div>;
  
  // const user = booking.user ?? null;
  const displayName =
    (user && ((user.first_name || user.last_name) ? `${user.first_name ?? ""} ${user.last_name ?? ""}`.trim() : user.name || user.full_name)) ||
    booking.guest_name ||
    "";
  const displayEmail = (user && (user.email || user.email_address)) || booking.guest_email || "";
  const displayPhone =
    (user && (user.phone_number || user.phone || user.mobile)) ||
    booking.guest_phone ||
    "";

  return (
    <div className={styles.reservationDetails}>
      <div className={styles.topSection}>
        <div className={styles.imageColumn}>
          <img
              src={
                booking.room?.images && booking.room.images.length > 0
                  ? getImageUrl(booking.room.images[activeImage])
                  : slideImages[activeImage]
              }
            alt="Room"
            className={styles.mainImage}
          />
          <div className={styles.thumbnailRow}>
            {booking.room?.images && booking.room.images.length > 0 ? (
              booking.room.images.map((image, index) => (
                <img
                  key={index}
                  src={getImageUrl(image)}
                  alt={`Room view ${index + 1}`}
                  className={activeImage === index ? styles.active : ''}
                  onClick={() => setActiveImage(index)}
                />
              ))
            ) : (
              <>
                <img 
                  src="/images/slide1.jpg" 
                  alt="Room view 1" 
                  className={activeImage === 0 ? styles.active : ''}
                  onClick={() => setActiveImage(0)}
                />
                <img 
                  src="/images/slide2.jpg" 
                  alt="Room view 2" 
                  className={activeImage === 1 ? styles.active : ''}
                  onClick={() => setActiveImage(1)}
                />
                <img 
                  src="/images/slide3.jpg" 
                  alt="Room view 3" 
                  className={activeImage === 2 ? styles.active : ''}
                  onClick={() => setActiveImage(2)}
                />
              </>
            )}
          </div>
        </div>

        <div className={styles.infoColumn}>

          <div className={styles.reservationHeader}>
            <div>
              <span className={styles.roomId}>Room Type ID: {booking.room?.id}</span>
              <p className={styles.paymentInfo}>
                Payment made on {booking.payment_date ? new Date(booking.payment_date).toLocaleDateString() : new Date(booking.created_at).toLocaleDateString()} at {booking.payment_date ? new Date(booking.payment_date).toLocaleTimeString() : new Date(booking.created_at).toLocaleTimeString()}
              </p>
            </div>
            <span className={styles.amount}>
              ₦{booking.total_amount?.toLocaleString()}
            </span>
          </div>

          <h2 className={styles.roomTitle}>
            {booking.room?.title || booking.room?.name || "Standard Room"}
          </h2>
          <p className={styles.price}>
            ₦{booking.room?.price?.toLocaleString()} Per Night
          </p>
          <p className={styles.statusPill}>{booking.status?.toUpperCase()}</p>

          <p className={styles.description}>
            {booking.room_id?.description || "A cozy yet stylish space featuring a King-size bed, modern furnishings, and a private en-suite bathroom with optimum cleanliness. Enjoy high-speed Wi-Fi, a smart TV, workspace, and 24/7 room service. Perfect for solo travelers or budget-conscious guests."}
          </p>

          {/* Guest/User Information */}
          <div className={styles.formGroups} style={{ marginBottom: '1.5rem' }}>
            <label>Guest/User Name</label>
            <input
              type="text"
              value={displayName} readOnly
            />
            <label>Guest/User Email</label>
            <input
              type="text"
              value={displayEmail}
              readOnly
            />
            <label>Guest Phone</label>
            <input type="text" value={displayPhone} readOnly />
          </div>

          <div className={styles.featuresGrid}>
            <div>
              <FaBed /> King-size bed
            </div>
            <div>
              <FaShower /> Private bathroom
            </div>
            <div>
              <FaSnowflake /> Air conditioning
            </div>
            <div>
              <FaWifi /> Wi-Fi
            </div>
            <div>
              <FaTv /> Smart TV
            </div>
            <div>
              <FaLaptop /> Workspace
            </div>
            <div>
              <FaConciergeBell /> 24/7 Room Service
            </div>
          </div>

          {/* Read-only Booking Info */}
          <div className={styles.currentBooking}>
            <div className={styles.formGroups}>
              <label>Dates</label>
              <input
                type="text"
                value={`Payment made on ${booking.start_date ? new Date(booking.start_date).toLocaleDateString() : new Date(booking.created_at).toLocaleDateString()} at ${booking.end_date ? new Date(booking.payment_date).toLocaleTimeString() : new Date(booking.created_at).toLocaleTimeString()}`}
                disabled
              />
            </div>
            <div className={styles.formGroups}>
              <label>Airport Conveyance</label>
              <input
                type="text"
                value={booking.includes_pickup ? "Airport Pickup" : "Nogne"}
                disabled
              />
            </div>
          </div>

          {/* Editable Fields */}
          <div className={styles.editForm}>
            <h4>Make Edits To Your Reservation</h4>
            <p className={styles.noticeWarning}>
              Modifying your booking may result in changes to your total cost or
              availability. Some changes may incur additional charges or may not
              be allowed based on the hotel’s policies.
            </p>
            <div className={styles.formGroups}>
              <label>New Dates</label>
              <input type="text" defaultValue="12/03 - 25/07" />
            </div>
            <div className={styles.formGroups}>
              <label>Airport Conveyance</label>
              <select>
                <option>None</option>
                <option selected>Airport Pickup</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <section className={styles.reviewsSection}>
        <h3>Reviews</h3>
        <ReviewsSection roomTypeId={booking?.room?.room_type_id} bookingId={booking?.id} />
      </section>

      <section className={styles.feedbackForm}>
        <h3>Leave a Review</h3>
        <ReviewForm bookingId={booking?.id} />
      </section>
    </div>
  );
};

export default ReservationDetails;
